import classNames from 'classnames'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CIVILISATION_ID } from '../../app/constants'
import { Info } from '../../assets/img'
import { setPopUp } from '../../features/popUpSlice/popUpSlice'
import { extractStake } from '../../utilities/extractStake'
import { Commander } from '../containers/Commander'
import { PercentageDisplay } from '../containers/PercentageDisplay'
import Button from '../ui/Button'
import { MissionDifficultyIndex } from '../ui/MissionDifficultyIndex'
import StakeSlot from '../ui/staking/StakeSlot'

const MissionDayTwo = ({ civilisation }) => {
  const stakingInfo = useSelector((state) => state.stakeInfo)
  const sparksAmount = stakingInfo.sparksAmount;
  const sparks = stakingInfo.sparks;
  const epochInfo = useSelector((state) => state.epoch)
  const dispatch = useDispatch()
  const fullCollection = useSelector(
    (state) => state.galaktikaCollection.fullNFTCollection,
  )

  

  const [selected, setSelected] = useState({ name: 'Mining', id: 1 })
  const [hasSelected, setHasSelected] = useState(false)

  // Query Info for the selected Civilisation
  const epochCiv = epochInfo.epochDetails.filter(
    (i) => i.civilization === CIVILISATION_ID[civilisation],
  )

  // Query User Info for the previous day selected civilisation
  const userEpochCiv = epochInfo.userEpochDetails.filter(
    (i) =>
      i.civilization === CIVILISATION_ID[civilisation] &&
      i.epoch_id === epochInfo.epoch,
  )

  const userEpochSpark = sparks.filter(
    (i) =>
      epochCiv.map(e => e.id.includes(i.stakeepoch_id)),
  )
  console.log(userEpochCiv)

  useEffect(() => {
    if (userEpochCiv[0] || userEpochSpark[0]) {
      setHasSelected(true)
    }
  }, [sparks, userEpochCiv, userEpochSpark])

  // Calculate Percentages for each mission type
  const civTotals = []
  let civTotal = 0

  const missionPercentages = []

  epochCiv.forEach((item) => civTotals.push(extractStake(item.total_staked)))

  for (let i = 0; i < civTotals.length; i++) {
    civTotal = civTotal + civTotals[i]
  }

  civTotals.forEach((item) => {
    if (civTotal === 0) {
      missionPercentages.push(0)
    } else {
      missionPercentages.push(Math.round((item / civTotal) * 100))
    }
  })

  // Query User Stake

  const userStake = userEpochCiv[0]
    ? extractStake(userEpochCiv[0].total_staked)
    : 0

  // Manage Tabs

  const [activeTab, setActiveTab] = useState('Resource Cards');
  const stakingCards = stakingInfo.stakingCards;
  const userStakedCard = stakingInfo.userNFTStakingDetails;

  useEffect(() => {
    console.log(
      'DEBUGGING:',
      fullCollection?.filter((e) => e.immutable_data.series === civilisation),
      civilisation,
    )
  })

  // userStakedCard.sort((a, b) => a.nft_type_id - b.nft_type_id)

  console.log('DEBUGGING USERSTAKEDCARDS:', userStakedCard)

  
  
  
  console.log("DEBUGGING STAKED AMOUNT", sparksAmount)
  const tabs = [
    {
      title: 'Resource Cards',
      description: 'Required to fuel mission',
      cards: [
        { type_name: 'Spark', type: 'Spark' },
      ],
      userCards:[userEpochSpark],
    },
    {
      title: 'Civilisation Cards',
      description: '3 cards required',
      cards: [stakingCards[0], stakingCards[1], stakingCards[2]],
      userCards: [userStakedCard[0], userStakedCard[1], userStakedCard[2]],
    },
    {
      title: 'Special Cards',
      description: 'Gain extra mission power',
      cards: [stakingCards[3]],
      userCards: [userStakedCard[3]],
    },
    // {
    //   title: 'Synergy Cards',
    //   description: 'Gain extra mission power',
    //   cards: [{ title: 'Synergy' }, { title: 'Synergy' }, { title: 'Synergy' }],
    // },
  ]


  const handleSelect = () => {
    setHasSelected(true)
  }

  const handleClick = (missionType, id) => {
    setSelected({ name: missionType, id })
  }

  return (
    <>
      {!hasSelected ? (
        <section className="lg:ml-16 lg:pb-6 pt-4 xl:pb-8 flex pb-4 overflow-x-hidden mx-auto lg:w-full md:flex-nowrap flex-wrap justify-center gap-3 p-4 md:p-0 md:pb-8 lg:px-4 xl:pr-10 pl-3 lg:pt-0 overflow-auto container__mission--grid">
          <div
            className="absolute top-[3%] right-[3%] cursor-pointer"
            onClick={() =>
              dispatch(setPopUp({ isOpen: true, status: 'info-2' }))
            }
          >
            <Info />
          </div>
          <div className="hidden max-h-[45vh] 2xl:max-h-[50vh] lg:flex justify-center">
            <Commander civilisation={civilisation} />
          </div>
          <div className="lg:w-full w-full 2xl:pl-10 3xl:pl-12 md:w-1/2 col-span-2">
            <div className="grid gap-x-3 grid-cols-2  pt-7 xl:pt-10 2xl:pt-20">
              <div className="col-span-1 md:ml-4 md:mx-2 xl:mx-5 flex flex-col justify-between">
                <h3 className="text-cyanBlue uppercase self-center pb-4">
                  Select Mission
                </h3>
                <div className="grid grid-rows-3 gap-y-4">
                  <Button
                    onClick={() => handleClick('Mining', 1)}
                    responsive
                    active={selected.name === 'Mining'}
                    className="w-full"
                  >
                    Mining
                  </Button>
                  <Button
                    responsive
                    onClick={() => handleClick('Exploration', 2)}
                    active={selected.name === 'Exploration'}
                    className="w-full"
                  >
                    Exploration
                  </Button>
                  <Button
                    responsive
                    onClick={() => handleClick('Invention', 3)}
                    active={selected.name === 'Invention'}
                    className="w-full"
                  >
                    Invention
                  </Button>
                </div>
              </div>
              <div className="col-span-1 xl:mr-10 flex flex-col justify-between">
                <h3 className="text-white self-center pb-4">
                  Total GLK staked
                </h3>
                <div className="grid grid-rows-3 gap-y-4">
                  <PercentageDisplay
                    total
                    isMP
                    mission={1}
                    civilization={civilisation}
                  />
                  <PercentageDisplay
                    total
                    isMP
                    mission={2}
                    civilization={civilisation}
                  />
                  <PercentageDisplay
                    total
                    isMP
                    mission={3}
                    civilization={civilisation}
                  />
                </div>
              </div>
            </div>

            <p className="text-cyanBlue mt-4 ml-4 lg:ml-5">{`${civilisation} ${selected.name} Mission Selected`}</p>

            <Button
              active={true}
              className="self-center w-full md:mt-12 mt-6 mb-3 md:ml-4 md:mx-2 xl:mx-5 "
              uppercase
              responsive
              onClick={(event) => handleSelect()}
            >
              Enter Mission
            </Button>
          </div>
          <div className="flex flex-col w-full lg:w-full items-center overflow-hidden  md:w-1/2 col-span-2">
            <MissionDifficultyIndex
              missionPercentages={missionPercentages}
              selected={selected}
            />
          </div>
        </section>
      ) : (
        <section className="flex h-full w-full flex-col overflow-auto lg:ml-24 pb-4 lg:pb-6 xl:pb-8">
          <div className="flex justify-between w-11/12 mx-auto py-8 pb-10 ">
            {tabs.map(({ title, description }, i) => (
              <Fragment key={title}>
                <div
                  value={title}
                  onClick={() => {
                    if (sparksAmount > 0) 
                    setActiveTab(title)
                  }}
                  className={ sparksAmount > 0 ? "cursor-pointer" : "cursor-not-allowed"}
                >
                  <h3
                    className={classNames(
                      activeTab === title ? 'text-cyanBlue' : sparksAmount > 0 ? 'text-white' : 'text-[#a4a4a4]',
                      ['uppercase'],
                    )}
                  >
                    {title}
                  </h3>
                  <p className="text-gold text-sm 2xl:text-base">
                    { title === "Resource Cards" ? description : sparksAmount > 0 ? description : "Stake 1 spark to continue"}
                  </p>
                </div>
                {i < 3 && (
                  <div className="border-r border-gold w-[1px] h-full"></div>
                )}
              </Fragment>
            ))}
          </div>
          {tabs.map((tab, i) => (
            <div
              key={i + tab.title}
              className={classNames(
                activeTab === tab.title
                  ? 'opacity-1 lg:grid flex flex-col'
                  : 'opacity-0 hidden',
                [
                  'lg:grid-cols-3 2xl:w-2/3 xl:w-5/6 w-3/5 lg:w-11/12 mx-auto px-10 gap-10',
                ],
              )}
            >
              {tab.cards.map(
                (card, i) =>
                  card && (
                    <StakeSlot
                      key={i}
                      title={card.type_name}
                      type={card.type_id}
                      userStake={userStake}
                      civilisation={civilisation}
                      mission={selected?.id}
                      templateId={
                        false ?
                        card.template_ids[CIVILISATION_ID[civilisation] + 1]?.template_ids 
                        : fullCollection?.filter(
                            (e) => e.immutable_data.series?.includes("SP"),
                          )
                          .map((e) => e.template_id)
                      }
                      userCards={tab?.userCards?.filter(
                        (e) =>
                          e?.civilization === CIVILISATION_ID[civilisation] &&
                          e?.mission === selected.id &&
                          e?.nftType_id === card?.type_id,
                      )}
                    />
                  ),
              )}
            </div>
          ))}
        </section>
      )}
    </>
  )
}

export default MissionDayTwo
